import { defineComponent } from 'vue';
import NavigatorComponent from './navigator/NavigatorComponent.vue';
import BreadcrumbComponent from './breadcrumb/BreadcrumbComponent.vue';
import FooterComponent from '../footer/FooterComponent.vue';

export default defineComponent({
  name: 'LayoutComponent',
  components: {
    NavigatorComponent,
    BreadcrumbComponent,
    FooterComponent,
  }
});
